<template>
  <section>
    <div 
      class="
        flex 
        text-sp-primary 
        p-2 mb-6 
        w-full 
        border border-white border-opacity-20 
        bg-sp-secondary bg-opacity-70 
        rounded-md
        transition-all duration-150 ease-in-out
        focus-within:ring-1 focus-within:ring-sp-accent
        focus-within:border-sp-accent
      "
    >
      <img
        src="@/assets/icon-search.png"
        alt="Search"
        class="w-6 h-6 pointer-events-none"
      />
      <input
        v-model="query"
        @keydown="onKeydown"
        type="text"
        enterkeyhint="search"
        :placeholder=placeholder
        class="w-full pl-2 bg-transparent focus:outline-none"
      />
    </div>
  </section>
</template>


<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useTranslate } from '../composables/useTranslate'

const query = ref('')
const router = useRouter()
const { t, getTranslation } = useTranslate()

const placeholder = getTranslation('search')

function onKeydown(event) {
  if (event.key === 'Enter' && query.value.trim()) {
    router.push({ name: 'SearchResult', query: { query: query.value.trim() } })
  }
}
</script>